/* istanbul ignore file */
export default function getSafeRedirectUrl(
  redirectUrl: string | null | undefined,
): string | null | undefined {
  if (redirectUrl == null) {
    return null;
  }

  const replacedUrl = redirectUrl.replace(/\s/g, '');

  if (replacedUrl.startsWith('/') && !(replacedUrl[1] === '/' || replacedUrl[1] === '\\')) {
    return replacedUrl;
  }

  return null;
}
